'use strict';

const _ = require('lodash');
const Enum = require('./enum');
const BridgesConstants = require('./bridges');
const LocksConstants = require('./locks');
const DoobellsConstants = require('./doorbells');

/**
 * Defines devices.
 *
 * @enum
 * @readonly
 */
const Devices = Object.create(Enum, {
  BRIDGE: { value: 'connect', enumerable: true },
  LOCK: { value: 'lock', enumerable: true },
  LOCK_V5: { value: LocksConstants.LockVersions.V5, enumerable: true },
  KEYPAD: { value: 'keypad', enumerable: true },
  DOORBELL: { value: DoobellsConstants.DoorbellVersions.V1, enumerable: true },
  DOORBELL_V2: { value: DoobellsConstants.DoorbellVersions.V2, enumerable: true },
  DOORBELL_V3: { value: DoobellsConstants.DoorbellVersions.V3, enumerable: true },
  CHIME: { value: 'chime', enumerable: true },
  CAMERA: { value: 'camera', enumerable: true },
  HOMEKIT: { value: 'homekit', enumerable: true },
  ALEXA: { value: 'alexa', enumerable: true },
  NONE: { value: 'none', enumerable: true },
  hasClientCertificate: {
    value: function(device) {
      return (
        LocksConstants.LockVersions.hasClientCertificate(device) ||
        BridgesConstants.BridgeDeviceModelTypes.hasClientCertificate(device) ||
        DoobellsConstants.DoorbellVersions.hasClientCertificate(device)
      );
    },
    enumerable: false,
  },
  supportsTcpKeepAlive: {
    value: function(device) {
      const hasCaps = _.get(device, 'caps', []).includes('tcp_wakeup');

      return hasCaps || _.get(device, 'serialNumber', '').startsWith('D3');
    },
    enumerable: false,
  },
});

const DeviceMonitorEvents = Object.create(Enum, {
  LONGPOLL_OK_TELEMETRY_TIMEOUT: { value: 'longpoll_ok_telemetry_timeout', enumerable: true },
  LONGPOLL_TIMEOUT_TELEMETRY_OK: { value: 'longpoll_timeout_telemetry_ok', enumerable: true },
});

/**
 * Defines identifiers to distinguish between
 * devices versions.
 *
 * @enum
 * @readonly
 */
const DevicesVersions = Object.create(Enum, {
  getBridgeType: {
    value: function(bridge) {
      switch (bridge.deviceModel) {
        case BridgesConstants.BridgeDeviceModelTypes.AUGUST_CONNECT:
          return Devices.BRIDGE;
        case BridgesConstants.BridgeDeviceModelTypes.AUGUST_DOORBELL:
          if (/^D1/.test(bridge.mfgBridgeID)) {
            return Devices.DOORBELL;
          }
          if (/^D2/.test(bridge.mfgBridgeID)) {
            return Devices.DOORBELL_V2;
          }
          if (/^D3/.test(bridge.mfgBridgeID)) {
            return Devices.DOORBELL_V3;
          }

          return Devices.NONE;
        case BridgesConstants.BridgeDeviceModelTypes.AUGUST_LOCK:
          return LocksConstants.LockVersions.V5;

        default:
          return Devices.NONE;
      }
    },
  },
});

exports.Devices = Devices;
exports.DeviceMonitorEvents = DeviceMonitorEvents;
exports.DevicesVersions = DevicesVersions;
